import React from "react";
import i18n from "i18next";
import { getLanguageInit } from "./customerConfig";
const lang = getLanguageInit();

const i18nextConfig = {
  lng: lang,
  fallbackLng: lang,
  fallbackNS: "frontend",
};
// add resources to i18nextConfig
i18nextConfig.resources = {
  fr: {
    frontend: require("../translations/fr/frontend.json"),
  },
  it: {
    frontend: require("../translations/it/frontend.json"),
  },
};

// Configure the local file backend
const fsBackend = {
  loadPath: `../translations/{{lng}}/{{ns}}.json`,
  addPath: `../translations/{{lng}}/{{ns}}.missing.json`,
};

const isDevelopmentEnv = process.env.NODE_ENV != "production";

const missingTranslationHandler = (lng, ns, key, fallbackValue) => {
  // Log the missing translation
  console.warn(`Missing translation: [${lng}] ${key}`);

  // Save the missing translation to a file or send it to a server
  // You can customize this part based on your needs

  // Example: Save to a JSON file
  const missingTranslations = {
    ...i18n.services.resourceStore.data[lng]?.[ns]?.translations,
    [key]: fallbackValue || key,
  };
  // Save the missing translations to a file
};

const options = {
  debug: false,
  initImmediate: false,
  preload: ["fr", "it"],
  lng: getLanguageInit(),
  fallbackLng: i18nextConfig.fallbackLng,
  fallbackNS: i18nextConfig.fallbackNS,
  interpolation: {
    escapeValue: false,
  },
  load: "languageOnly", // --> 'fr'
  ns: [i18nextConfig.fallbackNS], // string or array of namespaces to load
  defaultNS: i18nextConfig.fallbackNS,
  detection: {
    order: ["localStorage"],
    caches: ["localStorage"],
  },
  backend: {
    ...fsBackend,
    jsonIndent: 2, // Optional: Set the number of spaces for JSON indentation,
    allowMultiLoading: true,
  },
  resources: i18nextConfig.resources,
  saveMissing: isDevelopmentEnv, // save missing keys just when node env. is not production
  saveMissingTo: "all",
  updateMissing: isDevelopmentEnv, // update missing keys just when node env. is not production
  appendNamespaceToMissingKey: isDevelopmentEnv,
  missingKeyHandler: missingTranslationHandler,
};

export default options;
